import { render, staticRenderFns } from "./TaxEdit.vue?vue&type=template&id=08d15e22&"
import script from "./TaxEdit.vue?vue&type=script&lang=ts&"
export * from "./TaxEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports